import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import {
  FormlyFieldConfig,
  FormlyFormOptions,
  FormlyModule,
} from '@ngx-formly/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { Subscription } from 'rxjs'

import { ButtonComponent } from '../../components/button/button.component'
import {
  AuthException,
  CognitoService,
  UserCredentials,
} from '../../services/cognito.service'

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    ButtonComponent,
    SvgIconComponent,
    TranslatePipe,
    RouterLink,
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading: boolean = false

  public form = new FormGroup({})
  public model = {}
  public options: FormlyFormOptions = {}
  public fields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'flex flex-col gap-8',
      fieldGroup: [
        {
          type: '#email',
          props: {
            required: true,
          },
        },
        {
          type: '#password',
        },
        {
          key: 'stayLoggedIn',
          type: 'checkbox',
          props: {
            label: 'pages.login.stayLoggedIn',
          },
        },
      ],
    },
  ]
  private formChangeSub: Subscription = new Subscription()
  public loginError = ''

  public constructor(
    private readonly cognitoService: CognitoService,
    private readonly translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.formChangeSub = this.form.valueChanges.subscribe(() => {
      if (this.loginError) {
        this.resetAllFieldsErrorState()
        this.loginError = ''
      }
    })
  }

  public ngOnDestroy(): void {
    this.formChangeSub.unsubscribe()
  }

  private resetAllFieldsErrorState(): void {
    Object.keys(this.form.controls).forEach((fieldName) => {
      const field = this.form.get(fieldName)
      if (field) {
        field.setErrors(null)
      }
    })
  }

  private markAllAsErrorState(): void {
    Object.keys(this.form.controls).forEach((fieldName) => {
      const field = this.form.get(fieldName)
      if (field) {
        field.setErrors({})
      }
    })
  }

  public submit(): void {
    this.loading = true
    this.loginError = ''
    if (this.form.valid) {
      const input = this.model as UserCredentials
      this.cognitoService
        .signIn({
          email: input.email,
          password: input.password,
        })
        .catch((err: Error) => {
          switch (err.name as AuthException) {
            case 'NotAuthorizedException':
              this.loginError = this.translateService.instant(
                'validation.notAuthorizedLong'
              )
              this.form.get('email')?.setErrors({})
              this.form.get('password')?.setErrors({
                notAuthorized: true,
              })

              break
            case 'UserNotFoundException':
              this.markAllAsErrorState()
              this.loginError = this.translateService.instant(
                'validation.genericError'
              )
              break
            default:
              this.loginError = this.translateService.instant(
                'validation.genericError'
              )
              this.markAllAsErrorState()
              break
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
